// src/modules/app-views/_apps/appsindico/units/seed.js
import appService from 'services/appService';
import { generateUidV4 } from 'utils/helpers';

// *******************************************************************************
// DEFAULT SEEDS
// *******************************************************************************
const DEFAULT_SEEDS = {
  blocks: [
    {
      uid: generateUidV4(),
      name: 'Torre A',
      abbreviation: 'TA',
      number: 1,
      foreColor: '#FFFFFF',
      backColor: '#1890ff',
      totalFloors: 10,
      floorRanges: [{ from: 1, to: 10, unitsPerFloor: 4, label: '' }],
    },
  ],
  profiles: [
    {
      uid: generateUidV4(),
      name: 'Studio',
      m2: 30,
      unitDigits: 3,
    },
    {
      uid: generateUidV4(),
      name: '2 Quartos',
      m2: 60,
      unitDigits: 3,
    },
    {
      uid: generateUidV4(),
      name: '3 Quartos',
      m2: 90,
      unitDigits: 3,
    },
  ],
};

// *******************************************************************************
// SEED FUNCTION
// *******************************************************************************
async function seedUnitsParameters({ moduleId, storedParameters }) {
  if (!moduleId) return [];

  const moduleParams = storedParameters?.modules?.[moduleId];
  if (moduleParams && Object.keys(moduleParams).length > 0) return [];

  const results = [];

  // Seed blocks
  try {
    await appService.updateModulePreferences({
      category: 'blocks',
      moduleId,
      data: DEFAULT_SEEDS.blocks,
    });
    results.push({ category: 'blocks', seeded: true });
  } catch (error) {
    console.error('[seedUnitsParameters] Error seeding blocks:', error);
    results.push({ category: 'blocks', seeded: false, error });
  }

  // Seed profiles
  try {
    await appService.updateModulePreferences({
      category: 'profiles',
      moduleId,
      data: DEFAULT_SEEDS.profiles,
    });
    results.push({ category: 'profiles', seeded: true });
  } catch (error) {
    console.error('[seedUnitsParameters] Error seeding profiles:', error);
    results.push({ category: 'profiles', seeded: false, error });
  }

  return results;
}

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default seedUnitsParameters;
